export default {
    setPrescription(state, prescription) {
        state.prescription = prescription
    },
    setSelectedDrug(state, drug) {
        state.selectedDrug = drug
    },
    setEdition(state, edition) {
        state.edition = edition
    },
    resetPrescriptionState(state) {
        state.prescription = [];
        state.prescriptionId = null;
        state.revision = null;
        state.patientId = null;
        state.encounterId = null;
        state.contextPrescriptions = [];
        state.nextCursor = null;
        state.hasMore = false;
        state.contextSelectionRequired = false;
        state.readonly = false;
        state.initialized = false;
        state.selectedDrug = null;
        state.edition = false;
        state.files = [];
        state.shareDate = null;
        state.issuedPagesSnapshot = null;
        state.clinicalHandouts = [];
        state.professionalSnapshot = null;
    },
    setPrescriptionContext(state, { patientId = null, encounterId = null, readonly = false } = {}) {
        state.patientId = patientId;
        state.encounterId = encounterId;
        state.readonly = readonly;
    },
    setContextPrescriptions(state, { items = [], nextCursor = null, hasMore = false } = {}) {
        state.contextPrescriptions = items;
        state.nextCursor = nextCursor;
        state.hasMore = hasMore;
    },
    setContextSelectionRequired(state, required) {
        state.contextSelectionRequired = !!required;
    },
    clearActivePrescription(state) {
        state.prescription = [];
        state.prescriptionId = null;
        state.revision = null;
        state.files = [];
        state.shareDate = null;
        state.issuedPagesSnapshot = null;
        state.clinicalHandouts = [];
        state.professionalSnapshot = null;
        state.selectedDrug = null;
        state.edition = false;
    },
    hydratePrescription(state, prescription = {}) {
        state.prescription = prescription.pages || [];
        state.prescriptionId = prescription.id || null;
        state.revision = Number.isInteger(prescription.revision) ? prescription.revision : 0;
        state.patientId = prescription.patientId || state.patientId;
        state.encounterId = prescription.encounterId || state.encounterId;
        state.files = prescription.files ? [...prescription.files] : [];
        state.shareDate = prescription.shareDate || null;
        state.issuedPagesSnapshot = prescription.shareDate
            ? JSON.parse(JSON.stringify(prescription.pages || []))
            : null;
        state.professionalSnapshot = prescription.professionalSnapshot || null;
    },
    setPrescriptionInitialized(state, initialized) {
        state.initialized = initialized;
    },
}
